import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["colors"],
  _excluded2 = ["anchorRef", "colors"];
var _templateObject, _templateObject2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { Button } from '@material-ui/core';
import { spacing } from '@material-ui/system';
import React from 'react';
import styled from 'styled-components';
import { COLORS } from "../../constants/colors";
import { BLUE } from "../../constants/colors/hex";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var LinkButtonStyled = styled(function (_ref) {
  var colors = _ref.colors,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    border-radius: 0;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    padding: 0;\n\n    &,\n    &:active,\n    &:focus,\n    &:hover,\n    &:link,\n    &:visited {\n      background-color: transparent;\n      color: ", ";\n      text-decoration: underline;\n    }\n\n    &:hover {\n      text-decoration-thickness: 2px;\n    }\n\n    &:focus {\n      outline: ", " solid 1px;\n    }\n  }\n"])), COLORS.primary.main, BLUE[15]);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var ButtonStyled = styled(function (_ref2) {
  var anchorRef = _ref2.anchorRef,
    colors = _ref2.colors,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Button, _extends({
    ref: anchorRef
  }, props));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  && {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &.Mui-focusVisible {\n      box-shadow: 0 0 0 1px white, 0 0 0 3px ", ";\n    }\n\n    ", "\n  }\n\n  &.Mui-disabled {\n    background-color: ", "!important;\n    border-color: ", "!important;\n    color: ", "!important;\n    &:hover {\n      background-color: ", "!important;\n      border-color: ", "!important;\n      color: ", "!important;\n    },\n  }\n"])), function (props) {
  return props.colors.main.background;
}, function (props) {
  return props.colors.main.border;
}, function (props) {
  return props.colors.main.typography;
}, function (props) {
  return props.colors.hover.background;
}, function (props) {
  return props.colors.hover.border;
}, function (props) {
  return props.colors.hover.typography;
}, getFocusBorderColor, spacing, function (props) {
  return props.colors.disabled.background;
}, function (props) {
  return props.colors.disabled.border;
}, function (props) {
  return props.colors.disabled.typography;
}, function (props) {
  return props.colors.disabled.background;
}, function (props) {
  return props.colors.disabled.border;
}, function (props) {
  return props.colors.disabled.typography;
});
function getFocusBorderColor(props) {
  if (props.variant === 'outlined') {
    return props.colors.main.border;
  }
  if (props.variant === 'text') {
    return props.colors.main.typography;
  }
  return props.colors.main.background;
}